import { createSelector } from '@ngrx/store';

import { selectDashboardState } from '../dashboard.selectors';
import * as fromSubsections from './subsections.reducer';

export const selectSubsectionState = createSelector(selectDashboardState, (dashboard) => dashboard?.subsection);

export const selectSubsections = createSelector(selectSubsectionState, fromSubsections.selectAll);

export const selectSelectedSubsection = createSelector(
  selectSubsectionState,
  (subsectionState) => subsectionState?.selectedSubsection
);
